import { render, staticRenderFns } from "./ClockpickerPlate.vue?vue&type=template&id=7b22855a&"
import script from "./ClockpickerPlate.vue?vue&type=script&lang=js&"
export * from "./ClockpickerPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports